module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer2"
  }, [_c('div', {
    staticClass: "cop"
  }, [_c('a', {
    staticClass: "content-c3",
    attrs: {
      "href": "http://www.chengmeimedicine.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "content-c3"
  }, [_vm._v("© 2019-2021 CHENGMEI MEDICINE All Rights Reserved 琼ICP备2021008252号-1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b1700c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/footer.vue
// module id = 288
// module chunks = 2 3 5 11 12 15 21 26